import { render, staticRenderFns } from "./succeed.vue?vue&type=template&id=740cd1c6&scoped=true&"
import script from "./succeed.vue?vue&type=script&lang=js&"
export * from "./succeed.vue?vue&type=script&lang=js&"
import style0 from "./succeed.vue?vue&type=style&index=0&id=740cd1c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740cd1c6",
  null
  
)

export default component.exports